import * as React from 'react';
import { css } from '@emotion/css';
import { theme } from '@branchjs/neo-components';

import Tooltip from '../../../../../common/components/core/Tooltip';
import Input from '../../../../../common/components/core/Input';

const staticStyles = {
  rowContainer: css({
    display: 'flex',
  }),
  sectionTitle: css({
    fontWeight: theme.typography.h5.fontWeight,
    paddingBottom: '10px',
    fontSize: theme.typography.h5.fontSize,
    marginBottom: '0px',
    color: theme.colors.gray[800],
  }),
  sectionSubtitle: css({
    color: theme.colors.gray[700],
    fontSize: theme.typography.body2.fontSize,
    paddingBottom: '10px',
    marginTop: '-3px',
  }),
  infoIconContainer: css({
    marginTop: '2px',
    marginLeft: '5px',
  }),
};

class DiscoAdsCreatorFormSection extends React.Component {
  render() {
    const {
      title,
      subtitle,
      tooltipCopy,
      inputClassName,
      inputValue,
      inputIsDisabled,
      inputIsReadOnly,
      inputPlaceholder,
      onInputChange,
      onInputFocus,
      onInputBlur,
      component,
      charLimit,
      inputFieldClassName,
      testid,
    } = this.props;
    const dynamicStyles = {
      formSection: css({
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginBottom: `${charLimit ? '15px' : '33px'}`,
        '& input': {
          boxSizing: 'border-box',
          border: `0.7px solid ${theme.colors.gray.neutral}`,
          paddingLeft: '15px',
        },
      }),
      charLimitContainer: css({
        alignSelf: 'flex-end',
        color: `${charLimit === inputValue?.length ? theme.colors.error.main : theme.colors.gray[700]}`,
        fontSize: '11px',
        marginTop: '3px',
      }),
    };
    const { formSection, rowContainer, sectionTitle, sectionSubtitle, infoIconContainer, charLimitContainer } =
      Object.assign({}, staticStyles, dynamicStyles);
    return (
      <div className={formSection}>
        <div className={rowContainer}>
          <label className={sectionTitle}>{title}</label>
          {tooltipCopy && <Tooltip body={tooltipCopy} className={infoIconContainer} />}
        </div>
        {subtitle && <span className={sectionSubtitle}>{subtitle}</span>}
        {component && component()}
        {!component && (
          <Input
            className={inputClassName}
            inputClassName={inputFieldClassName}
            type="text"
            testid={testid}
            placeholder={inputPlaceholder}
            value={inputValue}
            disabled={inputIsDisabled}
            readOnly={inputIsReadOnly}
            onChange={onInputChange}
            onFocus={onInputFocus}
            onBlur={onInputBlur}
            i13nLabel="Disco Ads Creator Input"
            noFooter
          />
        )}
        {charLimit && <div className={charLimitContainer}>max {charLimit} characters</div>}
      </div>
    );
  }
}

export default DiscoAdsCreatorFormSection;
